<ul class="nav nav-tabs">
  @for (tab of tabs; track $index; let i = $index) {
    <li class="nav-item">
      <button (click)="setTab(i)" class="nav-link text-dark small bg-transparent" [class.active]="activeTab == i" aria-current="page">
        <small>{{tab}}</small>
      </button>
    </li>
  }
</ul>
@if (content) {
  <ng-container [ngTemplateOutlet]="tabsContent[activeTab].templateRef"></ng-container>
}
